module.exports = __webpack_public_path__ + "img/icon_address_wghn.99540b3d.svg";